import { getIsInitialPageLoaded } from 'redux/modules/page/selectors';
import { getCustomerDataIfLoggedIn } from 'redux/modules/sessions/get-customer-data-if-logged-in';

export default () => async (dispatch: WtrDispatch, getState: () => WtrState) => {
  if (getIsInitialPageLoaded(getState())) {
    return;
  }
  await getCustomerDataIfLoggedIn(dispatch, getState);
};
